import React, { useMemo } from "react";
import Icon from "../../components/Icon";
import PropTypes from "prop-types";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { getFiltersDate } from "../../utils/dateHelpers";
import { classNames } from "../../utils/helpers";
import { useQuery } from "@tanstack/react-query";
import CardSkeleton from "../ui/Skeleton/CardSkeleton";
import { FormatInt } from "../../utils/FormatData";

const Card = (props) => {
  const { title, icon, loading, value, text } = props;

  if (loading) return <CardSkeleton />;

  return (
    <>
      <div
        className={classNames(
          "flex flex-col p-6 transition-all duration-300 transform bg-white border rounded-lg bg-primary/10 dark:bg-primary/20 hover:scale-105"
        )}
      >
        <div className="flex items-center justify-between">
          <div className="text-lg font-bold text-gray-600 dark:text-background-light pb-3">
            {title}
          </div>
          <Icon icon={icon} className={classNames(text)} size={36} />
        </div>
        <p className="mt-2 text-3xl font-bold text-[#101922] dark:text-background-light">
          {FormatInt(value)}
        </p>
      </div>
    </>
  );
};
const HomeCards = (props) => {
  const { date } = props;
  const auth = useAuth();
  const channel = auth.getUserChannel();
  const { uid_partner, token, uid_user } = auth.getSessionData();
  const { start, end } = getFiltersDate(date);

  const { isPending, data } = useQuery({
    queryKey: ["homeCards", start, end, uid_partner],
    queryFn: async () => {
      const response = await httpClient(
        "post",
        `${ApiEndpoint}partner/report/messagesmry`,
        {
          from: start,
          to: end,
          user: uid_user,
          uidpartner: uid_partner,
        },
        token
      );
      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  const CARDS_ARRAY = [
    {
      title: "Total Enviados",
      icon: "all_inbox",
      value: data?.i_total ?? 0,
      key: "ALL",
      text: "text-[#019CFF]",
    },
    {
      title: "SMS",
      icon: "sms",
      value: data?.i_delivered ?? 0,
      key: "SMS",
      text: "text-cyan-600",
    },
    {
      title: "RCS",
      icon: "chat",
      value: data?.i_deliveredrcs ?? 0,
      key: "RCS",
      text: "text-indigo-600",
    },
  ];

  const visibleCards = useMemo(() => {
    if (channel.includes("ALL")) return CARDS_ARRAY;

    const keys = channel;
    return CARDS_ARRAY.filter(
      (card) => card.key === "ALL" || keys.includes(card.key)
    );
  }, [channel, data]);

  return (
    <div className="grid grid-flow-col  gap-4">
      {visibleCards.map((item, index) => {
        return (
          <Card
            key={index}
            title={item.title}
            value={item.value}
            icon={item.icon}
            loading={isPending}
            text={item.text}
          />
        );
      })}
    </div>
  );
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  value: PropTypes.number,
  text: PropTypes.string,
};

HomeCards.propTypes = {
  onChangeDate: PropTypes.func,
  date: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.number,
  ]),
};

export default HomeCards;
